import React from "react";

const FilterButtonIcon = () => {
  return (
    <svg
      id="Layer_1"
      height="20"
      width="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      fill="#f1f2f9"
    >
      <path d="m15 24-6-4.5v-5.12l-8-9v-2.38a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v2.38l-8 9zm-4-5.5 2 1.5v-6.38l8-9v-1.62a1 1 0 0 0 -1-1h-16a1 1 0 0 0 -1 1v1.62l8 9z" />
    </svg>
  );
};

export default React.memo(FilterButtonIcon);
